import { drop } from "lodash";

export const DOMAIN = drop(window.location.hostname.split(".")).join(".");

export const CHAT_ROOT = `//api.${window.location.hostname}/chat`;

let login_cb;

if (drop(DOMAIN.split(".")).join(".") === "finadv.cn") {
  login_cb = "https://wxcb.aifinsur.com/admin_login/" + DOMAIN.split(".")[0];
} else if (DOMAIN === "uat.aifinsur.com") {
  login_cb = "https://wxcb.aifinsur.com/admin_login/uat";
} else if (DOMAIN === "aifinsur.com") {
  login_cb = "https://wxcb.aifinsur.com/admin_login";
} else {
  window.console.error("未知的domain");
}

export const CHAT_URL =
  (window.location.protocol === "http:" ? "ws://" : "wss://") +
  CHAT_ROOT +
  "/chat-ready";
export const AGENT_CHAT_URL = (window.location.protocol === "http:" ? "ws://" : "wss://") +
  CHAT_ROOT +
  "/chat-agent";

export const WX_LOGIN_CB = login_cb;
export const WX_APPID = "wx6a042feb6e066f6e";

export const ORDER_RISK_MASK = {
  DEATH_ACCIDENT: "意外",
  DEATH_NOT_ACCIDENT: "非意外死亡",
  DEATH_PREMIUM: "重疾",
  MEDICARE_REIMBURSEMENT: "医疗",
  DISEASE_SERIOUS: "重症",
  DISEASE_NORMAL: "中症",
  DISEASE_MILD: "轻症"
};

export const ORDER_TYPE = {
  u: "用户录入",
  s: "系统推荐",
  b: "平台购买"
};

export const RIGHTS_CN = {
  vt: "访问时长",
  vc: "阅读次数",
  cp: "自定义名片位置",
  vas: "高级名片设置",
  pc: "产品对比",
  aca: "同屏换头像",
  pl: "产品库",
  ef: '剧场-财务讲解',
  cc: '剧场-保额计算',
  ctp: '剧场-生成方案',
};
